export const SELECTEDSCHEME = "SELECTEDSCHEME"